import { render, staticRenderFns } from "./StorePricesTable.vue?vue&type=template&id=82609692&scoped=true"
import script from "./StorePricesTable.vue?vue&type=script&lang=js"
export * from "./StorePricesTable.vue?vue&type=script&lang=js"
import style0 from "./StorePricesTable.vue?vue&type=style&index=0&id=82609692&prod&lang=css"
import style1 from "./StorePricesTable.vue?vue&type=style&index=1&id=82609692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82609692",
  null
  
)

export default component.exports